var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      ref: "btn",
      staticClass: "v-button",
      class: [
        _vm.sizeCss,
        _vm.typeCss,
        {
          [_vm.typeCss + "--disabled"]: _vm.disabled !== false,
          "v-button--inner": !_vm.$slots.default && _vm.type === "text",
        },
      ],
      attrs: { type: "button" },
      on: { click: _vm.clickBtn },
    },
    [
      !_vm.isLoading
        ? [
            _vm.icon
              ? _c("span", {
                  staticClass: "v-button__icon v-button__item",
                  class: _vm.icon,
                })
              : _vm._e(),
            _vm.$slots.default
              ? _c(
                  "span",
                  { staticClass: "v-button__item" },
                  [_vm._t("default")],
                  2
                )
              : _vm._e(),
            _vm.suffixIcon
              ? _c("span", {
                  staticClass: "v-button__icon v-button__item",
                  class: _vm.suffixIcon,
                })
              : _vm._e(),
          ]
        : [
            _c("span", {
              staticClass: "v-button--loading v-button__icon v-icon-loading",
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }